import React, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import {
    Box,
    Typography,
    TextField,
    Button,
    CircularProgress,
    CssBaseline,
    Toolbar,
    Snackbar,
    Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';

const Profile = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [userName, setUserName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [uid, setUid] = useState<string>('');
    const [tenantId, setTenantId] = useState<string | null>(null);
    const [newPassword, setNewPassword] = useState<string>('');
    const [message, setMessage] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const user = auth.currentUser;

                if (!user) throw new Error('User not authenticated.');

                setEmail(user.email || '');
                setUserName(user.displayName || 'Anonymous');
                setUid(user.uid);

                // Fetch the tenantId from the user's ID token claims
                const idTokenResult = await user.getIdTokenResult();
                console.log("idToken: ", idTokenResult);
                const tenantId = idTokenResult.claims.tenantId || null;
                if (typeof tenantId === 'string') {
                    setTenantId(tenantId);
                } else {
                    setTenantId(null); // set null if tenantId is not a valid string
                }


                setLoading(false);
            } catch (err: any) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    const handleLogout = async () => {
        try {
            await auth.signOut(); // Firebase logout
            navigate('/login'); // Redirect to login page after logout
        } catch (error) {
            console.error('Error logging out: ', error);
        }
    };

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ padding: 3 }}>
            <CssBaseline />
            <Toolbar />
            <Typography variant="h4" gutterBottom>
                Profile
            </Typography>

            {message && (
                <Snackbar open={true} autoHideDuration={6000} onClose={() => setMessage(null)}>
                    <Alert onClose={() => setMessage(null)} severity="success">
                        {message}
                    </Alert>
                </Snackbar>
            )}

            {error && (
                <Snackbar open={true} autoHideDuration={6000} onClose={() => setError(null)}>
                    <Alert onClose={() => setError(null)} severity="error">
                        {error}
                    </Alert>
                </Snackbar>
            )}

            <Typography variant="h6">Name</Typography>
            <TextField fullWidth value={userName} disabled sx={{ marginBottom: 3 }} />

            <Typography variant="h6">Email</Typography>
            <TextField fullWidth value={email} disabled sx={{ marginBottom: 3 }} />

            <Typography variant="h6">UID</Typography>
            <TextField fullWidth value={uid} disabled sx={{ marginBottom: 3 }} />

            <Typography variant="h6">Tenant ID</Typography>
            <TextField fullWidth value={tenantId || 'Not assigned'} disabled sx={{ marginBottom: 3 }} />

            <Button variant="contained" onClick={handleLogout} sx={{ color: 'white', backgroundColor: 'red' }}>
                Logout
            </Button>
        </Box>
    );
};

export default Profile;
